<template>
  <div class="product">
    <v-container v-if="product" class="pa-0 pa-md-3">
      <v-row class="pt-1 pl-4 pl-sm-0 pt-sm-5 d-none d-md-flex">
        <breadcrumbs :breadcrumbs="breadcrumbs" />
      </v-row>
      <v-row
        class="product-detail-container mt-0 mt-md-4 pt-0"
        :class="{ mobile: $vuetify.breakpoint.xsOnly }"
      >
        <v-col cols="12">
          <v-row class="product-detail">
            <v-col cols="12" offset-sm="1" sm="4">
              <div class="d-flex d-sm-none product-top mb-4 mb-md-0">
                <div class="product-logo" v-if="product.brand">
                  <v-img src="@/assets/3m.svg"></v-img>
                </div>
                <div class="flex-grow-1">
                  <h2 class="product-name">
                    {{ product.name }}
                  </h2>
                  <div v-if="product.subCategories.length > 0">
                    <img class="tag-icon" :src="require('@/assets/tag.svg')" />
                    <span class="product-tag ml-1">{{
                      product.subCategories[0].category.name +
                        "/" +
                        product.subCategories[0].name
                    }}</span>
                  </div>
                </div>
                <!-- <div class="d-flex mt-0 mt-md-8">
                  <div class="d-flex align-start">
                    <img
                      class="check-icon"
                      :src="require('@/assets/check-red.svg')"
                    />
                  </div>
                  <p class="ml-1 font-weight-bold font-14 mb-0 sales">
                    301 Sales
                  </p>
                </div> -->
              </div>

              <div
                class="carousel px-10 px-md-0"
                v-if="product.images"
                :class="{
                  'last-image': carousel === product.images.length - 1,
                  'first-image': carousel === 0
                }"
              >
                <v-carousel
                  hide-delimiters
                  :show-arrows="true"
                  height="296"
                  v-model="carousel"
                  v-if="product.images.length > 0"
                >
                  <v-carousel-item
                    v-for="image in product.images"
                    :key="image.id"
                    :src="image.imageUrl"
                  ></v-carousel-item>
                </v-carousel>
                <v-carousel
                  hide-delimiters
                  :show-arrows="false"
                  height="296"
                  v-model="carousel"
                  v-else
                >
                  <v-carousel-item
                    src="https://i.stack.imgur.com/y9DpT.jpg"
                  ></v-carousel-item>
                </v-carousel>
              </div>
              <v-row class="sub-imgs d-none d-sm-flex">
                <v-col
                  cols="3"
                  class="pb-0"
                  v-for="(image, index) in product.images"
                  :key="index"
                  :class="carousel === index ? 'active' : ''"
                  @click="carousel = index"
                >
                  <v-img :src="image.imageUrl"></v-img>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex flex-column">
              <div class="d-flex justify-space-between">
                <h2 class="product-name d-none d-sm-flex">
                  {{ product.name }}
                </h2>
                <div class="pointer" @click="toggleFavourite">
                  <v-icon :color="color">mdi-heart</v-icon>
                </div>
              </div>
              <div class="rating d-none d-sm-flex">
                <v-rating
                  readonly
                  dense
                  class="pl-0 product-rating"
                  v-model="product.reviewRating.average"
                  color="appOrange"
                  background-color="#d3d3d3"
                  empty-icon="mdi-star"
                ></v-rating>
                <span>{{product.reviewRating.average}} ({{product.reviewRating.outOf}})</span> <span class="ml-2"> | </span> <span>              Sold By {{product.supplier.name}} </span>

              </div>
              <div class="d-flex d-sm-none justify-space-between">
                <div class="rating">
                  <v-rating
                    readonly
                    class="pl-0 product-rating"
                    v-model="rating"
                    color="appOrange"
                    background-color="#d3d3d3"
                    empty-icon="mdi-star"
                    size="20"
                  ></v-rating>
                  <span>(4.4)</span>
                </div>
                <!-- <div class="discount">
                  <v-img src="@/assets/discount-bg.svg"></v-img>
                  <div class="name">10% OFF</div>
                </div> -->
              </div>
              <div
                class="product-price d-flex d-sm-none align-center justify-space-between my-4"
              >
                <div v-if="isLoggedIn" class="price">
                  £{{ product.amount.toFixed(2) }}
                </div>
                <!-- <div class="stock">7 in Stock</div> -->
              </div>
             
              <!-- <div class="product-logo d-none d-sm-flex" v-if="product.brand">
                <v-img :src="product.brand.logo"></v-img>
              </div> -->
              <div class="gotham-medium mb-2 d-none d-md-block">
                <!-- <u>Sold by {{ product.supplier.name }}</u> -->
              </div>
              <v-tabs
                fixed-tabs
                v-model="tab"
                :background-color="$vuetify.breakpoint.xsOnly ? '#fff' : '#fff'"
                :color="$vuetify.breakpoint.xsOnly ? '#23A0A0' : '#fff'"
                dark
              >
                <v-tab v-for="tab in tabs" :key="tab.tab" class="d-flex"
                  >{{ tab.tab }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab" class="mb-10 mb-md-0">
                <v-tab-item v-for="tab in tabs" :key="tab.tab">
                  <v-card flat>
                    <v-card-text class="pa-0 px-0 py-4 px-md-4 py-md-4">{{
                      tab.content
                    }}</v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
              <div class="product-tool-bottom">
                <div
                  class="product-total d-flex d-sm-none align-center justify-space-between mb-4"
                >
                  <div class="product-total-counter">
                    <v-btn
                      depressed
                      outlined
                      color="#aaa"
                      min-width="36"
                      @click="popFromBasket(product)"
                      >-</v-btn
                    >
                    <span class="mx-5">{{ quantity }}</span>
                    <v-btn
                      depressed
                      color="#aaa"
                      min-width="36"
                      @click="addToBasket(product)"
                      >+</v-btn
                    >
                  </div>
                  <div class="total">
                    Total : <span class="appRed--text">£{{ total }}</span>
                  </div>
                </div>
                <div class="product-tool d-flex d-sm-none align-center mt-4">
                  <v-btn
                    depressed
                    color="#23A0A0"
                    min-width="72"
                    height="48"
                    class="flex-grow-1 buy"
                    @click="$router.push({ name: 'Basket' })"
                    >Checkout</v-btn
                  >
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row class="product-view d-none d-md-flex d-sm-flex">
            <v-col class="col-12 col-md-10 offset-md-1">
              <div class="d-flex justify-space-between">
                <div class="review-label">
                  REVIEWS
                </div>
                <div class="d-flex justify-start align-center">
                  <div class="price-label mr-2" v-if="isLoggedIn">
                    PRICE
                  </div>
                  <div class="price mr-4" v-if="isLoggedIn">
                    £{{ product.amount }}
                  </div>
                  <!-- <v-btn
                    v-if="isLoggedInAndSurgeryApproved"
                    @click="pushToBasket"
                    color="appGreen"
                    class="white--text d-none d-md-block"
                    >ADD TO BASKET</v-btn
                  > -->
                  <v-btn
                    @click="pushToBasket"
                    color="appGreen"
                    class="white--text d-none d-md-block"
                    >ADD TO BASKET</v-btn
                  >
                </div>
              </div>
              <v-btn
                @click="pushToBasket"
                v-if="isLoggedInAndSurgeryApproved"
                color="appGreen"
                class="white--text d-block d-md-none"
                >ADD TO BASKET</v-btn
              >
            </v-col>
          </v-row>
          <v-row class="d-none d-md-flex">
            <v-col cols="10" offset="1">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <!-- Product Reviews -->

          <v-row class="d-none d-md-flex" v-if="productReviews.length > 0">
            <v-col cols="10" class="offset-md-1">
              <div class="rating d-flex align-center">
                <v-rating
                  readonly
                  dense
                  class="pl-0 product-rating mr-1"
                  v-model="averageProductRating"
                  color="appOrange"
                  background-color="#d3d3d3"
                  empty-icon="mdi-star"
                ></v-rating>
                <span class="mr-2">{{averageProductRating}}</span>
                <span>({{totalProductReviews}})</span>
              </div>

                <!-- {{productReviews}} -->
                <Review />
            </v-col>
          </v-row>
          <v-row v-else> 
            <v-col cols="10" class="offset-md-1">
             No Reviews Available
            </v-col>
            </v-row>
        </v-col>
      </v-row>
      <!-- Related Products -->
      <!-- <v-row class="related-products-title d-none d-sm-flex mt-4 mt-sm-0">
        <h2>OTHER RELATED PRODUCTS</h2>
        <div class="underline">View All Products</div>
      </v-row>
      <v-row class="related-products d-none d-sm-flex">
        <template v-for="relatedProduct in relatedProducts">
          <v-col
            cols="12"
            sm="6"
            md="6"
            lg="3"
            class="d-flex flex-column align-center"
            :key="relatedProduct.id"
          >
            <product-card :product="relatedProduct" :discount="false" />
          </v-col>
        </template>
      </v-row> -->
    </v-container>
    <v-container fluid class="pa-0">
      <home-footer class="d-none d-md-block" />
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Breadcrumbs from "@/components/Shared/Breadcrumbs/Breadcrumbs.vue";
import HomeFooter from "@/components/Shared/HomeFooter/HomeFooter.vue";
// import DiscountLabel from '@/components/Shared/DiscountLabel/DiscountLabel.vue'
// import ProductCard from "@/components/Shared/ProductCard/ProductCard.vue";
import Review from "@/components/Shared/Review/Review.vue";
export default {
  name: "ProductComponent",
  components: {
    Breadcrumbs,
    // DiscountLabel,
  //  ProductCard,
    HomeFooter,
    Review
  },
  data: () => ({
    breadcrumbs: ["SEARCH PAGE", "PRODUCT DETAILS"],
    carousel: 0,
    items: [
      {
        src: "product-detail.png"
      },
      {
        src: "product-detail.png"
      },
      {
        src: "product-detail.png"
      },
      {
        src: "product-detail.png"
      }
    ],
    rating: 4,
    tab: null
  }),
  computed: {
    ...mapState({
      basket_products: state => state.product.basketProducts,
      relatedProducts: state => state.product.relatedProducts,
      product: state => state.product.product,
      productReviews: state => state.product.productReviews,
      totalProductReviews: state => state.product.totalProductReviews,
      averageProductRating: state => state.product.averageProductRating,
      isFavourite: state => state.product.isFavourite
    }),
    isLoggedIn() {
      return this.$store.state.auth.token !== null ? true : false;
    },
    isLoggedInAndSurgeryApproved() {
      return this.$store.state.auth.user.utype == 'surgery';
    },
    quantity() {
      let basketProduct = this.$store.state.product.basketProducts.find(
        product => product.id == this.product.id
      );
      return basketProduct ? basketProduct.quantity : 0;
    },
    total() {
      return this.quantity * this.product.amount;
    },
    color() {
      return this.isFavourite ? "appRed" : "#aaaaaa";
    },
    tabs() {
      return [
        {
          tab: "Details",
          content: this.product.description
        },
        // {
        //   tab: this.$vuetify.breakpoint.xsOnly
        //     ? "Delivery"
        //     : "Delivery & Returns",
        //   content: this.product.description
        // },
        // {
        //   tab: "Specifications",
        //   content: this.product.description
        // }
      ];
    }
  },
  methods: {
    async toggleFavourite() {
      this.$swal({
        title: !this.isFavourite? 'Add product to favourites': 'Removing product from favourites',
        html: 'This may take a while',
        icon: 'info',
        onOpen: () => {
          this.$swal.showLoading();
        }
      })
      await this.$store.dispatch("product/TOGGLE_FAVOURITE", this.product.id);
      this.$swal({
        title: 'Success',
        html: !this.isFavourite? 'Successfully remove product from favourites' : 'Successfully add product to favourites',
        icon: 'info'
      })
    },
    async pushToBasket() {
      this.evtPushProductToCart(this.product);
      this.$swal({
        title: "Adding to Basket",
        icon: "info",
        toast: true,
        position: "top-end",
        timer: 1000,
        onOpen: () => {
          this.$swal.showLoading();
        },
        onClose: () => {
          this.$store.commit("product/ADD_ITEM_TO_BASKET", this.product);
        }
      });
    },
    addToBasket(product) {
      this.evtPushProductToCart(product);
      this.$swal({
        title: "Adding to Basket",
        icon: "info",
        toast: true,
        position: "top-end",
        timer: 1000,
        onOpen: () => {
          this.$swal.showLoading();
        },
        onClose: () => {
          this.$store.commit("product/ADD_ITEM_TO_BASKET", product);
        }
      });
    },
    popFromBasket(product) {
      this.evtPopProductFromCart(product);
      this.$swal({
        title: "Removing from Basket",
        icon: "info",
        toast: true,
        position: "top-end",
        timer: 1000,
        onOpen: () => {
          this.$swal.showLoading();
        },
        onClose: () => {
          this.$store.commit("product/POP_DISH_FROM_BASKET", product);
        }
      });
    },
    async pushToBasketWithQuantity() {
      this.evtPushProductToCart(this.product, this.quantity);
      this.$swal({
        title: "Adding to Basket",
        icon: "info",
        toast: true,
        position: "top-end",
        timer: 1000,
        onOpen: () => {
          this.$swal.showLoading();
        },
        onClose: () => {
          for (let index = 0; index < this.quantity; index++) {
            this.$store.commit("product/ADD_ITEM_TO_BASKET", this.product);
          }
        }
      });
    },
    navigateToBasket() {
      this.$router.push({ name: "Basket" });
    },
    changeQuantity(i) {
      if (i) {
        this.quantity++;
      } else {
        const quantity = this.quantity - 1;
        if (quantity) {
          this.quantity--;
        }
      }
    }
  }
};
</script>
<style scoped lang="scss" src="./Product.scss"></style>
<style lang="scss">
.last-image
  .v-window__next
  button.v-btn.v-btn--flat.v-btn--icon.v-btn--round.theme--dark.v-size--default {
  display: none;
}
.first-image
  .v-window__prev
  button.v-btn.v-btn--flat.v-btn--icon.v-btn--round.theme--dark.v-size--default {
  display: none;
}
.rating {
  .v-rating {
    .v-icon {
      padding: 0 !important;
    }
  }
}
</style>
